export enum WalletTypeEnum {
  REAL = 'real',
  DEMO = 'demo',
  BONUS = 'bonus',
  BONUS_PIECES = 'bonus_pieces',
  FREE_COINS = 'free-coins',

  QUEST_WALLET_1 = 'quest-wallet-1',
  QUEST_WALLET_2 = 'quest-wallet-2',

  EVENT_WALLET_1 = 'event-wallet-1',

  SEASON_BRONZE_TICKET = 'season-bronze-ticket', // 600
  SEASON_SILVER_TICKET = 'season-silver-ticket', // 601
  SEASON_GOLD_TICKET = 'season-gold-ticket', // 602
  SEASON_DIAMOND_TICKET = 'season-diamond-ticket', // 603
}


export enum WalletTypeIdEnum {
  REAL = 1,
  DEMO = 2,
  BONUS = 3,
  BONUS_PIECES = 4,
  FREE_COINS = 5,

  QUEST_WALLET_1 = 500,
  QUEST_WALLET_2 = 501,

  EVENT_WALLET_1 = 502,

  SEASON_BRONZE_TICKET = 600,
  SEASON_SILVER_TICKET = 601,
  SEASON_GOLD_TICKET = 602,
  SEASON_DIAMOND_TICKET = 603,
}
